<template>
  <v-navigation-drawer
    v-model="showDrawer"
    right
    temporary
    fixed
    width="1400"
    @transitionend="closeHandler"
  >
    <v-toolbar
      fixed
      dense
      flat
      dark
      class="primary"
    >
      <v-btn
        icon
        @click.stop="closeHandler(false)"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <span>
        {{ title }}
      </span>
    </v-toolbar>

    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
      >
        <!-- mini statistic start -->
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <slot />
        </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'RightDrawer',

  props: {
    open: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String,
      default: 'Back'
    }
  },

  computed: {
    showDrawer: {
      get () {
        return this.open
      },
      set (value) {
        this.closeHandler(value)
      }
    }
  },

  methods: {
    closeHandler (value) {
      if (!value) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped></style>
